import { get, isAPIError } from '@user/store/services/crud'
import { toast } from '@sales-center/components'
import { baseUrl } from '../constants'
import { fetchAllActivityTypesActionCreator } from '../state'

export async function fetchAllActivityTypes() {
  const response = await get(baseUrl)
  const result = await response.json()

  if (!response.ok) {
    if (isAPIError(result.payload)) {
      toast.error(result.payload.Message)
    } else {
      toast.error('Failed to load Activity Types')
    }
    return fetchAllActivityTypesActionCreator([])
  }

  return fetchAllActivityTypesActionCreator(result)
}
